<template>
  <!-- eslint-disable -->
  <div
    class="gradient"
    :style="{color: start, background: 'linear-gradient(' + start + ', ' + stop + ')'}"
  >
    <transition name="pouf">
      <span v-if="!scrolled" class="gradient__text">
        <strong>scroll to change color shift</strong>
      </span>
    </transition>
  </div>
</template>

<script>
/*eslint-disable */
export default {
  name: 'Bg',
  props: {
    stop: String,
    start: String,
    scrolled: Boolean
  }
};
</script>

